import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../services/auth/auth.service";
import { BaseComponent } from "../BaseComponent";
import { ActivatedRoute, Router } from "@angular/router";
import { UserModel } from "../../models/UserModel";
import { Platform } from "@ionic/angular";
import { ServiceChangesService } from "../service-changes/service/service-changes.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { ProviderDefault } from "src/models/ProviderDefault";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
})
export class MenuComponent extends BaseComponent implements OnInit {
  showMenu: boolean;
  showMenuMobile: boolean;
  user: UserModel;
  showMasterDataUser: boolean;
  mobile: boolean;
  contentMainClass: any;
  menuStructureList: any;
  providerCod: string = "";
  urlReportBI: string = "";
  providerDefaultSelected: ProviderDefault = {
    cod: "DXC",
    dateInsert: 0,
    dateUpdate: 0,
    deleteDate: 0,
    deleted: 0,
    description: "",
    firstMonth: "",
    id: 0,
    idUserInsert: 0,
    idUserUpdate: 0,
    inContTypeSett: "",
    lastConsolidatedMonth: "",
    lastMonth: "",
    lastUploadedBilling: "",
    lastUploadedCharging: "",
    lastUploadedKynBandwidth: "",
    lastUploadedVolume: "",
  };
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    router: Router,
    route: ActivatedRoute,
    private authService: AuthService,
    platform: Platform,
    private serviceChangesService: ServiceChangesService
  ) {
    super(route, router);
    this.showMenu = false;
    this.showMenuMobile = false;
    this.mobile = this.checkMobile(platform);
    this.user = JSON.parse(sessionStorage.getItem("user"));


    this.serviceChangesService.providerDefault$.pipe(takeUntil(this.destroy$)).subscribe({
      next: res =>{
        if(res){
          this.providerDefaultSelected = res;
          this.providerCod = res.cod;

          if(this.providerCod.includes("KYN")){
            this.urlReportBI = "https://app.powerbi.com/links/HKnQMDbYQm?ctid=d852d5cd-724c-4128-8812-ffa5db3f8507&pbi_source=linkShare";
          }
          else {
            this.urlReportBI = "https://app.powerbi.com/links/z6wyQ6YAyb?ctid=d852d5cd-724c-4128-8812-ffa5db3f8507&pbi_source=linkShare";
          }
        }
        this.menuStructureList = this.filterMenuByRoleAndProvider(
          this.providerCod
        );
      }
    })
    this.serviceChangesService.providerFilterValue$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res && res.cod) {
            this.providerCod = res.cod;
            
            if(this.providerCod.includes("KYN")){
              this.urlReportBI = "https://app.powerbi.com/links/HKnQMDbYQm?ctid=d852d5cd-724c-4128-8812-ffa5db3f8507&pbi_source=linkShare";
            }
            else {
              this.urlReportBI = "https://app.powerbi.com/links/z6wyQ6YAyb?ctid=d852d5cd-724c-4128-8812-ffa5db3f8507&pbi_source=linkShare";
            }
          }
          this.menuStructureList = this.filterMenuByRoleAndProvider(
            this.providerCod
          );
        },
      });

    if (this.user) {
      this.showMasterDataUser =
        this.user.roleList[0].toLowerCase() !==
        this.ROLE.GESTORE_LC.toLowerCase();
    } else {
      this.router.navigate(["login"]);
    }
    this.contentMainClass = document.getElementsByClassName("content-main")[0];
    console.log("this.contentMainClass: ", this.contentMainClass);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  async ngOnInit() {
    this.showMenu = this.authService.isAuthenticated();
  }

  closeMenu() {
    this.showMenuMobile = false;
    this.contentMainClass.classList.remove("resize-main");
  }

  openMenu() {
    this.showMenuMobile = !this.showMenuMobile;
    if (!this.mobile && this.showMenuMobile) {
      this.contentMainClass.classList.add("resize-main");
    } else {
      this.contentMainClass.classList.remove("resize-main");
    }
  }

  onResize(event) {
    if (event.target.innerWidth <= 1024) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }
}
